var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebappShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#webapp_share_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.181.214c-1.21 0-2.197.95-2.258 2.145-.785.22-1.274.358-1.738.542-.51.202-.983.456-1.79.912A2.265 2.265 0 0 0 .556 6a2.261 2.261 0 0 0 2.837 2.187c.808.456 1.28.71 1.791.912.464.184.953.321 1.738.542a2.261 2.261 0 1 0 .301-1.25c-.77-.218-1.178-.334-1.565-.487a9.217 9.217 0 0 1-1.056-.515c.299-.383.477-.865.477-1.39 0-.523-.178-1.005-.477-1.388.454-.248.75-.394 1.056-.515.387-.153.795-.27 1.565-.487a2.26 2.26 0 0 0 4.219-1.133A2.261 2.261 0 0 0 9.18.214Z",
  fill: "#3A434A"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "webapp_share_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
})))));
export default SvgWebappShare;